import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { MediaBreakPointUp } from '@lean-body/components/styles';
import { PlaylistComponentSquare, PlaylistComponentLandscapeImg } from '@lean-body/components/molecules';
export const Playlists = ({ classObject, playlists, onClickPlaylist, addFavoriteProgram, unFavoriteProgram, isSM, }) => {
    if (!playlists) {
        return null;
    }
    return (React.createElement("div", { className: css(styles.container, classObject) }, playlists.map((playlist, i) => (React.createElement("div", { className: css(styles.playlistCard), key: i }, isSM ? (React.createElement(PlaylistComponentSquare, { playlist: playlist, addFavoriteProgram: addFavoriteProgram, unFavoriteProgram: unFavoriteProgram, isMin: isSM })) : (React.createElement(PlaylistComponentLandscapeImg, { key: playlist.id, playlist: playlist, addFavoriteProgram: addFavoriteProgram, unFavoriteProgram: unFavoriteProgram, isVertical: !isSM, onClick: onClickPlaylist })))))));
};
const styles = StyleSheet.create({
    container: {},
    playlistCard: {
        width: 163,
        [MediaBreakPointUp.MD]: {
            width: '100%',
        },
    },
});
